import { createApp } from "vue";
import App from "./App.vue";

import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
import "./../scss/custom.scss";

const app = createApp(App);

import router from "./router";
app.use(router);

import store from "./store";
app.use(store);

// Google アナリティクス
import VueGtag from "vue-gtag-next";
app.use(VueGtag, { property: { id: "G-VL362EESVS", router } });

import { createI18n } from "vue-i18n";
import { messages } from "@/lib/lang/index.js";
const i18n = createI18n({
  locale: "en",
  messages
});
app.use(i18n);

app.mount("#app");

// if (process.env.NODE_ENV != "development") {
//   window.console.log = function(i) {
//     return;
//   };
// }
